import {
  CellRange,
  GetContextMenuItemsParams,
  GridApi,
  MenuItemDef,
} from '@ag-grid-community/core'
import { FileDataModel } from './models/external-file-viewer'

export const generateUniqueFileKey = (
  { fileId, reconDate, fileType, accountId }: FileDataModel,
  gridKey?: string,
) => {
  gridKey = gridKey ? `${gridKey}_` : ''
  // when totalRows is -1, make sure reconDate does not have space in gridKey
  return `${gridKey}${accountId}_${fileId}_${fileType}_${reconDate
    .trim()
    .replace(' - ', '_')}`
}

/**
 * Context Menu Items
 */
export const contextMenuItems = (
  highlightMenuItems: MenuItemDef[],
  params: GetContextMenuItemsParams,
) => {
  return [
    'copy',
    'separator',
    ...highlightMenuItems,
    'separator',
    ...getPinMenuItems(params),
    'separator',
    'export',
  ]
}

export const getPinMenuItems = (params: GetContextMenuItemsParams) => {
  const selectedColumnIds = getSelectedColumnIds(params.api)
  return [
    {
      name: 'Pin Left',
      action: () => {
        params.columnApi.applyColumnState({
          state: selectedColumnIds.map(colId => ({ colId, pinned: 'left' })),
        })
      },
    },
    {
      name: 'Unpin',
      action: () => {
        params.columnApi.applyColumnState({
          state: selectedColumnIds.map(colId => ({ colId, pinned: null })),
        })
      },
    },
  ]
}

export const getSelectedColumnIds = (gridApi: GridApi): string[] => {
  const selectedIds = new Set<string>()
  const cellRanges = gridApi.getCellRanges()

  if (cellRanges) {
    cellRanges.forEach((cellRange: CellRange) => {
      cellRange.columns.forEach(column => {
        selectedIds.add(column.getColId())
      })
    })
  }
  return Array.from(selectedIds)
}
